import { Button } from 'react-bootstrap';
import React from 'react';

const ImageButton = (props) => {

    return (
      <Button className="btn_base" variant={props.selected ? "secondary": "link"} onClick={props.onPress} data-testid={props.testId}>
        {props.children}
      </Button>
    );

}

export default ImageButton
